import { hasFeature } from '@precert/has-feature';
import * as Yup from 'yup';

import { RequestedByType } from './form';

export default function schema(features: string[]) {
  return Yup.object().shape({
    email: Yup.string()
      .trim()
      .email('Email must be a valid email')
      .required('Email is required'),
    formType: Yup.string().when([], {
      is: () => !hasFeature('update-precert', features),
      then: () =>
        Yup.string()
          .trim()
          .required('Reporting as is required')
          .oneOf([RequestedByType.Provider]),
    }),
  });
}
